<!-- DownloadPDFButton.vue -->
<template lang="pug">
  button.Download-pdf-button.btn.btn-lg.btn-primary(
    :disabled="pdfUrl==''"
    @click="download()"
  ) 
    span(
      v-if="pdfUrl == ''"
    ) Generating Report <span class="mdi mdi-loading mdi-spin"></span>
    span(
      v-else
    ) Download Report
</template>

<script>

export default {
  name: "download-PDF-button",
  props: {
    pdfUrl: {
      type: String,
      default: '',
    }
  },
  methods: {
    download() {
      this.$emit('onDownload')
    }
  }
};
</script>